// File Metadata:
// Filename: ChecklistSection.js
// Version: 1.00
// Created: 2025-03-23 01:02:53
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState } from 'react'
import { 
    List, ListItem, ListItemText, ListItemIcon,
    Checkbox, TextField, Button, Box 
} from '@mui/material'
import { useAddQualityCheckMutation } from '../../api/receptionsApiSlice'

const defaultChecks = [
    { id: 'packaging', label: 'Packaging Condition', required: true },
    { id: 'quantity', label: 'Quantity Check', required: true },
    { id: 'documentation', label: 'Documentation Complete', required: true },
    { id: 'damage', label: 'Damage Inspection', required: true },
    { id: 'labeling', label: 'Proper Labeling', required: true }
]

const ChecklistSection = ({ receptionId }) => {
    const [addQualityCheck] = useAddQualityCheckMutation()
    const [checks, setChecks] = useState(defaultChecks.map(check => ({
        ...check,
        status: 'PENDING',
        notes: ''
    })))

    const handleCheckUpdate = async (checkId, field, value) => {
        const updatedChecks = checks.map(check => 
            check.id === checkId ? { ...check, [field]: value } : check
        )
        setChecks(updatedChecks)

        const check = updatedChecks.find(c => c.id === checkId)
        if (check) {
            try {
                await addQualityCheck({
                    id: receptionId,
                    check: {
                        checkId: check.id,
                        status: check.status,
                        notes: check.notes
                    }
                })
            } catch (err) {
                console.error('Failed to save check:', err)
            }
        }
    }

    return (
        <List>
            {checks.map((check) => (
                <ListItem key={check.id} divider>
                    <ListItemIcon>
                        <Checkbox
                            checked={check.status === 'PASS'}
                            onChange={(e) => handleCheckUpdate(
                                check.id, 
                                'status', 
                                e.target.checked ? 'PASS' : 'FAIL'
                            )}
                        />
                    </ListItemIcon>
                    <ListItemText 
                        primary={check.label}
                        secondary={check.required ? 'Required' : 'Optional'}
                    />
                    <TextField
                        size="small"
                        placeholder="Notes"
                        value={check.notes}
                        onChange={(e) => handleCheckUpdate(
                            check.id,
                            'notes',
                            e.target.value
                        )}
                    />
                </ListItem>
            ))}
        </List>
    )
}

export default ChecklistSection
